import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { INSTALLATION_TYPE } from '../../../constants/InstallationConstants'
import { nbPerPageLabelShort } from '../../../../referencial/constants/ReferencialConstants'
import { getDate } from '../../../../utils/DateUtil'
import BoreholeDescriptionPanel from '../../borehole/BoreholeDescriptionPanel'
import CaptureStationDescriptionPanel from '../../capture/CaptureStationDescriptionPanel'
import InstallationDescriptionPanel from '../../installationDefault/InstallationDescriptionPanel'
import LiftingStationDescriptionPanel from '../../liftingStation/LiftingStationDescriptionPanel'
import PumpingStationDescriptionPanel from '../../pumping/PumpingStationDescriptionPanel'
import STEPDescriptionPanel from '../../step/STEPDescriptionPanel'
import TankStationDescriptionPanel from '../../tank/TankStationDescriptionPanel'
import TreatmentStationDescriptionPanel from '../../treatment/TreatmentStationDescriptionPanel'
import DtoVisit from '../dto/DtoVisit'
import SectorAction from 'referencial/components/sector/actions/SectorAction'
import Icon from 'components/icon/Icon'
import { CardTable, NewTable } from 'components/datatable/NewTable'
import { greyBlue } from 'utils/constants/ColorTheme'
import { Accordion, AccordionDetails } from '@mui/material'
import { AccordionTitle } from 'components/styled/Accordions'

const HEADERS_MODIFICATIONS = ['field', 'initialValue', 'newValue', 'updateUser', 'updateDate', 'status']

const InstVisitModifications = ({
    visit = {},
    readMode = true,
    addNewChange = () => { },
}) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(SectorAction.fetchSectors())
    }, [])

    const {
        installation,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
    }), shallowEqual)

    const dataTable = visit.link_modifications.map(m => ({
        ...m,
        updateDate: getDate(m.updateDate),
        initialValue: m.previousValue,
        updateUser: m.updateLogin,
        status: !m.updateLogin && <Icon icon='unpublished' tooltip={i18n.notSync} />,
    }))

    const getDescriptionInstallation = () => {
        switch (installation.installationType) {
            case INSTALLATION_TYPE.BOREHOLE:
                return <BoreholeDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.LIFTING_STATION:
                return <LiftingStationDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.CAPTURE:
                return <CaptureStationDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.TANK:
                return <TankStationDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.TREATMENT:
                return <TreatmentStationDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.PUMPING:
                return <PumpingStationDescriptionPanel onChangeVisit={ addNewChange } />
            case INSTALLATION_TYPE.STEP:
                return <STEPDescriptionPanel onChangeVisit={ addNewChange } />
            default:
                return <InstallationDescriptionPanel onChangeVisit={ addNewChange } />
        }
    }

    const accordionName = `${i18n.modifications} (${dataTable.length} ${dataTable.length <= 1 ? i18n.element : i18n.elements})`

    return (
        <>
            { !readMode && (
                <Accordion sx={{ marginX: 1 }}>
                    <AccordionTitle title={accordionName}/>
                    <AccordionDetails>
                        <NewTable
                            rows={dataTable}
                            headers={HEADERS_MODIFICATIONS}
                            rowsPerPageOptions={nbPerPageLabelShort}
                        />
                    </AccordionDetails>
                </Accordion>
            ) || (
                <CardTable
                    title={i18n.modifications}
                    rows={dataTable}
                    color={greyBlue}
                    headers={HEADERS_MODIFICATIONS}
                    rowsPerPageOptions={nbPerPageLabelShort}
                />
            )}
            {!readMode && getDescriptionInstallation() }
        </>
    )
}

InstVisitModifications.propTypes = {
    visit: PropTypes.instanceOf(DtoVisit),
    readMode: PropTypes.bool,
    addNewChange: PropTypes.func,
}

export default InstVisitModifications
